import React, { useEffect, useRef } from "react";
import { container, header, title, content, text, backLink } from "./ourThoughts.css";
import { useNavigate } from "react-router-dom";

const OurThoughts: React.FC = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const target = entry.target as HTMLElement;
          if (entry.isIntersecting) {
            target.style.opacity = "1";
            target.style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.1 }
    );

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      if (contentRef.current) {
        observer.unobserve(contentRef.current);
      }
    };
  }, []);

  return (
    <div className={container}>
      <div ref={contentRef} className={content}>
        <div className={header}>
          <h1 className={title}>CONCEPT</h1>
        </div>
        <div className={text}>
          <p>
            "食べて楽しい料理のお店"<br />
            <br />
            「美味しいものを食べて楽しいひとときを過ごす」それだけではありません。<br />
            私達の使命は"身体は食べ物から作られる"当たり前のことを大切に、健康で楽しく食べ続けら<br />
            れる生活づくりを支援することです。<br />
            <br />
            何を食べるか選択は自由、しかし選択の結果は不自由な真実<br />
            <br />
            「いつまでも疲れが取れない」、「身体の調子が悪い」など原因は食べ物かもしれません。<br />
            便利さや手軽さの誘惑に負けて添加物まみれの食事を摂り続けると、蓄積疲労・睡眠不良など<br />
            様々な症状を引き起こすだけでなく、高血圧・糖尿病・脂質異常症・ 脂肪肝などの生活習慣病<br />
            を発症するリスクが高まります。<br />
            これらの病気を発症すると悲しいことに好きな物を食べられなくなり、また普段の生活の中で<br />
            違和感を感じないため放置されやすく、ある日突然重大な健康被害を引き起こす恐ろしい特徴<br />
            から別名"サイレントキラー"とも呼ばれ、私達の命を静かに奪い去る可能性も高まります。
          </p>
          <p>
            "そんなの嫌！美味しいものを食べ続けたい。死ぬわけない！"
          </p>
          <p>
            人は誰しも病気にはなりたくないですし、また自らの寿命を知ることはできません。<br />
            正常性バイアスが働き「自分は大丈夫、まさか自分が・・・」と。<br />
            <br />
            健康を守り続けるため体に良いものを食べる重要性は良く理解されていますが、忙しい現代<br />     
            社会では貴重な時間を少しでも節約したいと誰しもが思うもの。<br />
            疲れているし面倒だからと何かしらの理由を見つけて、自身の健康のことは二の次に・・・<br />
            ヘルシーなものは味気ないしサプリに頼るのも嫌、正直料理が苦手という方も多いと思います。<br />
            <br />
            私達は自分が安心して続けられる美味しい食べ物を通じ、これらのお悩みと負担を解消してお客様<br />
            の健康生活の質向上を目指します。<br />
            皆様の日常が笑顔に包まれ"食べて楽しい"毎日を迎えられることを願い料理を提供して参ります。
          </p>
          <p>
            "A restaurant where you can enjoy eating"
            <br />
            <br />
            "Eat delicious food and have a good time" is not the only thing we do.<br />
            Our mission is to support the creation of a healthy lifestyle where you can <br />
            continue to eat happily, while valuing the obvious fact that "your body is made from food."<br />
            <br />
            We are free to choose what to eat, but the truth is that the results of our choices are not free. <br />
            <br />
            "I can't get rid of my fatigue" or "I'm not feeling well" may be caused by food. <br />
            If we give in to the temptation of convenience and ease and continue to eat food full of additives, it will not only cause various symptoms such as accumulated fatigue and poor sleep, but it will also increase the risk of developing lifestyle-related diseases such as high blood pressure, diabetes, dyslipidemia, and fatty liver. <br />
            If you develop these diseases, you will sadly no longer be able to eat the foods you like, and they are easily left untreated because they do not feel strange in your daily life. They are also known as "silent killers" because of their terrible characteristics of suddenly causing serious health damage one day, and they may quietly take our lives.
          </p>
          <p>
            "I don't want that! I want to keep eating delicious food. I can't die!"
          </p>
          <p>
            No one wants to get sick, and no one can know their own lifespan. <br />
            Normalcy bias = You somehow think you're fine, and you never thought it would happen to you... <br />
            <br />
            It is well understood that eating healthy foods is important to maintain good health, but <br />
            we tend to neglect protecting our health, using excuses such as being busy or it's too much of a bother... <br />
            Furthermore, no one wants to give up their favorite foods for the sake of their health, and frankly, many people aren't good at cooking. <br />
            In today's busy society, everyone wants to save as much precious time as possible. <br />
            Therefore, in order to solve these problems, we aim to improve the quality of our customers' healthy lives through food. <br />
            We hope that your daily lives will be filled with smiles and that you will be able to "eat and enjoy" every day, so we will provide delicious food.
          </p>
        </div>
        <span
          onClick={() => navigate('/')}
          className={backLink}
          role="link"
          tabIndex={0}
          style={{ cursor: 'pointer' }}
        >
          トップへ戻る
        </span>
      </div>
    </div>
  );
};

export default OurThoughts; 